module.exports = __webpack_public_path__ + "img/Experience.b7f885b5.svg";